module.exports = __webpack_public_path__ + "static/thiago-e8a1df909fab76dcb4bd205612711f71.jpg";